module.exports = __webpack_public_path__ + "static/1-309ccabb697a319e71aeec896e7c6553.jpg";